import PropTypes from 'prop-types';

import { withFormField } from '@gogame/form';

import MenuItem from '../components/MenuItem';
import { useSelectedCategory } from '../UserPermissions';

const PermissionPickerCategory = withFormField({
  padding: 0,
})(({ id, label, value, options, disabled, area }) => {
  const { selected, onChangeCategory } = useSelectedCategory({ id });

  const count = value?.length;
  const total = (area.data || options)?.length;

  return (
    <MenuItem
      label={label}
      count={count || 0}
      total={area.loading ? '-' : total || 0}
      disabled={disabled}
      selected={selected}
      onClick={onChangeCategory}
    />
  );
});

PermissionPickerCategory.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  source: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.object),
  depends: PropTypes.arrayOf(PropTypes.string),
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
};

export default PermissionPickerCategory;
